/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { FilterCollation, FilterOperation } from '../enums';

import type { PredicateExpression } from '../interfaces';


export function toPredicateExpression(
    property: string,
    value: string | number,
    operation: FilterOperation = FilterOperation.Equals,
    collation: FilterCollation = FilterCollation.Ordinal,
): PredicateExpression {
    return {
        property,
        operation,
        value,
        collation,
    };
}
